import styled from 'styled-components';

export const ContainerTable = styled.div`
  display: grid;
  grid-template-rows: 65px 1fr;
  grid-gap: 10px;
`;
